import { PaymentTypesPayload } from '../../../../../../../../../utils/reducers/payments/paymentTypes'
import { PaymentMethodsPayload } from '../../../../../../../../../utils/reducers/payments/paymentMethods'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { useCallback, useMemo, useState } from 'react'
import { FormRender } from '../../../../../../../../../forms/FormRenderer/types'
import { addDictionaryExtraLine, TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import { ButtonsModalSmallCentered, ModalMediumCentered } from '../../../../../../../../../baseComponents/Modal'
import TwinTrans from '../../../../../../../../../baseComponents/TwinTrans'
import FormRenderer from '../../../../../../../../../forms/FormRenderer'
import { ModalEditComponentPropsWithoutSubmit } from '../../../../../../../../../baseComponents/ModalsLayouts/types'
import './modalFiltersNewRemittance.sass'
import { parsePresearchFiltersNewRemittance } from './functions'

type ModalFiltersNewRemittanceProps = ModalFiltersNewRemittanceLogicProps & ModalEditComponentPropsWithoutSubmit &{
    paymentTypes: PaymentTypesPayload
    paymentMethods: PaymentMethodsPayload
}

const ModalFiltersNewRemittance: React.FC<ModalFiltersNewRemittanceProps> = ({ paymentTypes, paymentMethods, setOpened, ...logic }) => {
    const {t} = useTwinTranslation()
    const { handleChangePresearchFilter, readyToSearch } = useModalFiltersNewRemittanceLogic({ ...logic })
    const memoPaymentTypes = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(paymentTypes?.all))), [paymentTypes])
    const memoPaymentMethods = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(paymentMethods?.active || {}))), [paymentMethods])
    const fields: FormRender<any> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'from',
                    label: t('from', 'Desde'),
                    component: 'InputCalendarStateFull',
                    onlyValids: true,
                    onChange: (value) => handleChangePresearchFilter('from', value),
                    className: 'text-left'
                },
                {
                    name: 'to',
                    label: t('to', 'Hasta'),
                    component: 'InputCalendarStateFull',
                    onlyValids: true,
                    onChange: (value) => handleChangePresearchFilter('to', value),
                    className: 'text-left'
                },
                {
                    name: 'PaymentTypeId',
                    label: t('paymentType', 'Tipo de pago'),
                    component: 'CustomSelectWithSearchBar',
                    onChange: (value) => handleChangePresearchFilter('PaymentTypeId', value),
                    sortItems: true,
                    items: memoPaymentTypes
                },
                {
                    name: 'PaymentMethodId',
                    label: t('paymentMethod', 'Método de pago'),
                    component: 'CustomSelectWithSearchBar',
                    onChange: (value) => handleChangePresearchFilter('PaymentMethodId', value),
                    sortItems: true,
                    items: memoPaymentMethods
                },
            ]
        }
    ]
    return (
        <ModalMediumCentered className='modal_filters_new_remittance' opened={true} setOpened={setOpened}>
            <h2><TwinTrans transKey='filterToNewRemittance'>Filtrar para Nueva remesa</TwinTrans></h2>
            <FormRenderer sections={fields} className='my-40'  />
            <ButtonsModalSmallCentered confirmText={t('search', 'Buscar')} onAccept={readyToSearch} setOpened={()=>{}} onCancel={()=>setOpened(null)} />
        </ModalMediumCentered>
    )
}

interface ModalFiltersNewRemittanceLogicProps {
    setPreSearchFilters: React.Dispatch<React.SetStateAction<TwinDictionary | null>>
}

const useModalFiltersNewRemittanceLogic = ({ setPreSearchFilters }: ModalFiltersNewRemittanceLogicProps) => {
    const [myFilters, setMyFilters] = useState<TwinDictionary>({})
    const handleChangePresearchFilter = useCallback((field: string, value: string) => {
        setMyFilters((old)=>{
            let copyOld = JSON.parse(JSON.stringify(old))
            const parseFnc: TwinDictionary = {
                from: () => {return value ? { '$gteN': new Date(value) } : undefined},
                to: () => { return value ? { '$lteN': new Date(value) } : undefined}
            }
            if(parseFnc[field]){
                copyOld[field] = parseFnc[field]?.()
            } else {
                copyOld[field] = value
            }
            return copyOld
        })
    }, [setMyFilters])

    const readyToSearch = useCallback(() => {
        setPreSearchFilters(parsePresearchFiltersNewRemittance(myFilters))
    }, [setPreSearchFilters, myFilters ])

    return { handleChangePresearchFilter, readyToSearch }
}


export default ModalFiltersNewRemittance